import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useBrandContext } from "../context/BrandContext";
import { DEFAULT_BRAND_NAME } from "../constants/brand";

type ProtectedRouteProps = {
  children: JSX.Element;
};

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isLogged } = useAuth();
  const brandContext = useBrandContext();
  const location = useLocation();

  if (!isLogged()) {
    const brandName = brandContext?.brandName || DEFAULT_BRAND_NAME;

    // Remove o segmento da marca do caminho para guardar a rota tentada.
    // /spott/coupons -> /coupons, /qualquerMarca/coupons -> /coupons
    const segments = location.pathname.split("/").filter(Boolean);
    const attemptRoute = `/${segments.slice(1).join("/")}`;

    localStorage.setItem("attemptRoute", attemptRoute);
    return <Navigate to={`/${brandName}/login`} replace />;
  }
  return children;
};

export default ProtectedRoute;
